import * as React from "react";
const SvgMenu = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 6H21M3 12H21M3 18H21", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }));
export default SvgMenu;
